import { useVendorContext } from "@/contexts/vendor-context";
import useUniversalRouter from "@/hooks/use-universal-router";
import { getNavLabel } from "@/utils/navigation";
import Head from "next/head";
import { useEffect, useState } from "react";

const DocumentTitle = ({
  override,
  extraSegments = [],
}: {
  override?: string;
  extraSegments?: (string | undefined)[];
}) => {
  const { pathname } = useUniversalRouter();
  const { selectedVendor, getVendorSettings } = useVendorContext();
  const vendorSettings = getVendorSettings(selectedVendor);
  const [title, setTitle] = useState("Sesamy Portal");

  useEffect(() => {
    const parts = pathname.split("/").filter(Boolean);
    const segments = ["Sesamy Portal"];

    if (vendorSettings?.name) {
      segments.push(vendorSettings.name);
    }

    if (override) {
      segments.push(override);
    } else {
      // parts[0] = vendorId, parts[1] = section, parts[2+] = entityId/sub-section
      const routeParts = parts[0] === "v" ? parts.slice(2) : parts.slice(1);
      const [section, entityId] = routeParts;

      if (section) {
        segments.push(getNavLabel(section.replace(/-/g, "_")));
      }
      if (entityId) {
        segments.push(getNavLabel(entityId.replace(/-/g, "_")));
      }
    }
    if (extraSegments.length > 0) {
      segments.push(...extraSegments.filter((s): s is string => !!s));
    }

    const dynamicTitle = segments.join(" — ");
    document.title = dynamicTitle;
    setTitle(dynamicTitle);
  }, [pathname, vendorSettings, extraSegments, override]);

  return (
    <Head>
      <title>{title}</title>
    </Head>
  );
};

export default DocumentTitle;
